import React from 'react';
import PropTypes from 'prop-types';

import {Pill, Stack} from 'views/components';
import {translate} from 'views/module';

{/* Logic and ui for selecting which correspondance type to view */}
const SelectCorrespondanceType = (props) => {
  const {
    corType,
    setCorType,
  } = props;

  const filterTypeKeys = Object.keys(corType);

  const getFilterLabel = (type) => {
    switch (type) {
      case 'COMMENTS':
        return translate('client.ClientDetail.Correspondance.Type.Comments');
      case 'ANNOUNCEMENTS':
        return translate('client.ClientDetail.Correspondance.Type.Announcements');
      case 'LOGS':
        return translate('client.ClientDetail.Correspondance.Type.Logs');
      case 'CALENDLY_UPDATE':
        return translate('client.ClientDetail.Correspondance.Type.CalendlyUpdate');
      case 'DIALPAD_SMS_TEXT':
        return translate('client.ClientDetail.Correspondance.FilterPills.Sms');
      case 'DIALPAD_CALL_TRANSCRIPT':
        return translate('client.ClientDetail.Correspondance.FilterPills.Call');
      case 'EMAIL':
        return translate('client.ClientDetail.Correspondance.FilterPills.Email');
      default:
        return type;
    }
  };

  const isAllSelected = filterTypeKeys.every((type) => corType[type]);

  const onFilterClick = (type) => {
    if (isAllSelected) {
      setCorType(filterTypeKeys.reduce((output, key) => {
        output[key] = key === type;
        return output;
      }, {}));
      return;
    }

    setCorType({
      ...corType,
      [type]: !corType[type],
    });
  };

  const onAllClick = () => {
    setCorType(filterTypeKeys.reduce((output, key) => {
      output[key] = true;
      return output;
    }, {}));
  };

  return (
    <Stack
      direction='row'
      spacing={0.75}
      sx={{
        flexWrap: 'wrap',
        rowGap: 0.75,
      }}
    >
      <Pill
        label={translate('client.ClientDetail.Correspondance.FilterPills.All')}
        onClick={onAllClick}
        role='button'
        sx={{
          'borderRadius': '20px',
          'borderColor': isAllSelected ? '#EBBDAD' : '#E8E4DE',
          'backgroundColor': isAllSelected ? '#FFF7F4' : '#F9F8F6',
          'cursor': 'pointer',
          'height': '24px',
          'px': '12px',
          'py': '5px',
        }}
        textColor={isAllSelected ? '#DA7955' : '#6B6760'}
        labelSx={{
          fontFamily: 'inherit',
          fontSize: '12px',
          lineHeight: '14px',
        }}
      />
      {
        filterTypeKeys.map((type) => {
          const selected = !isAllSelected && Boolean(corType[type]);

          return (
            <Pill
              key={type}
              label={getFilterLabel(type)}
              onClick={() => onFilterClick(type)}
              role='button'
              sx={{
                'borderRadius': '20px',
                'borderColor': selected ? '#EBBDAD' : '#E8E4DE',
                'backgroundColor': selected ? '#FFF7F4' : '#F9F8F6',
                'cursor': 'pointer',
                'height': '24px',
                'px': '12px',
                'py': '5px',
              }}
              textColor={selected ? '#DA7955' : '#6B6760'}
              labelSx={{
                fontFamily: 'inherit',
                fontSize: '12px',
                lineHeight: '14px',
              }}
            />
          );
        })
      }
    </Stack>
  );
};
SelectCorrespondanceType.propTypes = {
  corType: PropTypes.shape({
    ANNOUNCEMENTS: PropTypes.bool.isRequired,
    COMMENTS: PropTypes.bool.isRequired,
    LOGS: PropTypes.bool.isRequired,
    CALENDLY_UPDATE: PropTypes.bool.isRequired,
    DIALPAD_SMS_TEXT: PropTypes.bool.isRequired,
    DIALPAD_CALL_TRANSCRIPT: PropTypes.bool.isRequired,
    EMAIL: PropTypes.bool.isRequired,
  }).isRequired,
  setCorType: PropTypes.func.isRequired,
};

export default React.memo(SelectCorrespondanceType);
